import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { generateApiKey, fetchUserApiKeys, deleteApiKey } from 'api/user'
import { ApiKeysContainer, ApiKeyTitle, ApiKeyButton, ApiKeyList, ApiKeyItem, ApiKeyText, DeleteButton } from '../style'

const ProfileApiKeys = () => {
  const [apiKey, setApiKey] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    loadApiKey()
  }, [])

  const handleGenerateApiKey = async () => {
    setIsLoading(true)
    try {
      const response = await generateApiKey()
      if (response && response.apiKey) {
        setApiKey(response.apiKey)
      }
    } catch (error) {
      console.error('Failed to generate API key:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleDeleteApiKey = async () => {
    try {
      await deleteApiKey()
      setApiKey(null)
    } catch (error) {
      console.error('Failed to delete API key:', error)
    }
  }

  const loadApiKey = async () => {
    setIsLoading(true)
    try {
      const response = await fetchUserApiKeys()
      if (response && response.apiKey) {
        setApiKey(response.apiKey)
      }
    } catch (error) {
      console.error('Failed to fetch API key:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ApiKeysContainer>
      <ApiKeyTitle>
        <FormattedMessage id="apiKeysTitle" />
      </ApiKeyTitle>

      <div hidden={apiKey}>
        <ApiKeyButton onClick={handleGenerateApiKey} disabled={isLoading}>
          <FormattedMessage id="generateApiKey" />
        </ApiKeyButton>
      </div>

      <div hidden={!apiKey} style={{width:"60%", maxWidth:"868px"}}>
        <ApiKeyList>
          <ApiKeyItem>
            <ApiKeyText value={apiKey} readOnly />
            <DeleteButton onClick={handleDeleteApiKey}>
              <FormattedMessage id="delete" />
            </DeleteButton>
          </ApiKeyItem>
        </ApiKeyList>
      </div>
    </ApiKeysContainer>
  )
}

export default ProfileApiKeys
